import axiosInstance from "services/axiosMiddleware";

export async function createLibraryAsana(asanaData){
  console.log("asanaData",asanaData)
    try{
        const response = await axiosInstance.post('library/createLibraryAsana', asanaData);
        return response;
        
    }catch (error) {
    console.error('Error creating Asana:', error);
    throw error; 
  }
}